/* eslint-disable jsx-a11y/alt-text */
import dayjs from "dayjs";
import React, { useMemo } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { useNavigate, useParams } from "react-router-dom";
import { useProductGroupById } from "../../../../api/product-group/use-product-group-detail";
import TitlePage from "../../../../components/section/TitlePage/Titlepage";
import Button from "../../../../components/ui/Button/Button";
import Card from "../../../../components/ui/Card/Card";
import InputDate from "../../../../components/ui/InputDate/InputDate";
import Modal from "../../../../components/ui/Modal/Modal";
import FieldBox from "../../../../utils/Form/ui/FieldBox";
import ProductList from "./Section/ProductListTable";
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";
import EditorViewer from "../../../../components/EditorViewer";

const ProductGroupDetailPage = () => {
  const { id } = useParams();
  const { data } = useProductGroupById(id);
  const defaultValues = data?.data;
  const navigate = useNavigate();

  const descriptionHtml = useMemo(() => {
    const converter = new QuillDeltaToHtmlConverter(
      JSON.parse(defaultValues?.description).ops
    );
    return converter.convert();
  }, [defaultValues?.description]);

  const handleEdit = () => {
    navigate("edit");
  };

  const handleBack = () => {
    navigate("/product-management/product-group");
  };

  return (
    <div>
      <TitlePage title="상품조회 > 상품정보 상세" />

      <>
        <ol className="mt-5">
          <li>
            <h2 className="font-bold text-sm">
              1. 상품 그룹의 노출 및 판매 상태
            </h2>
            <Card className="mt-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="w-32">노출 상태</div>
                  <div className="flex gap-8">
                    <div className="flex gap-1 items-center">
                      <input
                        type="radio"
                        className="flex-none accent-primary-black"
                        value="ON"
                        id="y"
                        disabled={true}
                        defaultChecked={defaultValues?.status === "ON"}
                      />
                      <label htmlFor="y">Y</label>
                    </div>
                    <div className="flex gap-1 items-center">
                      <input
                        type="radio"
                        className="flex-none accent-primary-black"
                        value="OFF"
                        id="n"
                        disabled={true}
                        defaultChecked={defaultValues?.status === "OFF"}
                      />
                      <label htmlFor="n">N</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center mt-4">
                <div className="w-32">판매 상태</div>
                <div className="flex gap-8">
                  <div className="flex gap-1 items-center">
                    <input
                      type="radio"
                      className="flex-none accent-primary-black"
                      value="SALE"
                      id="정상"
                      disabled={true}
                      defaultChecked={defaultValues?.saleStatus === "SALE"}
                    />
                    <label htmlFor="정상">정상</label>
                  </div>
                  <div className="flex gap-1 items-center">
                    <input
                      type="radio"
                      className="flex-none accent-primary-black"
                      value="NOT_SALE"
                      id="판매종료"
                      disabled={true}
                      defaultChecked={defaultValues?.saleStatus === "NOT_SALE"}
                    />
                    <label htmlFor="판매종료">판매종료</label>
                  </div>
                </div>
              </div>
            </Card>
          </li>
          <li className="mt-6">
            <h2 className="font-bold text-sm mb-3">2. [공통] 기본 정보</h2>
            <FieldBox label="상품번호">
              <div className="bg-white p-2 w-full">
                {defaultValues?.productNo}
              </div>
            </FieldBox>

            <FieldBox label="상품 그룹명">
              <div className="bg-white p-2 w-full">{defaultValues?.name}</div>
            </FieldBox>

            <FieldBox label="간략 설명">
              <div className="bg-white p-2 w-full">
                {defaultValues?.descriptionShort}
              </div>
            </FieldBox>

            <FieldBox label="검색어">
              <div className="flex items-center gap-1">
                {defaultValues?.keywords?.map((val) => {
                  return (
                    <div
                      key={val}
                      className="flex gap-1 bg-[#eeeeee] rounded-[4px] p-2"
                    >
                      {val}
                      <div className="cursor-pointer">
                        <span className="text-[#cccccc]">X</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </FieldBox>

            <FieldBox label="카테고리">
              <div className="bg-white p-2 w-full">
                {defaultValues?.productGroupCategory?.name}
              </div>
            </FieldBox>

            <FieldBox label="할인">
              <div className="flex gap-1">
                <div className="flex flex-none items-center gap-3 w-[32%]">
                  <div className="flex gap-1 items-center">
                    <input
                      type="radio"
                      className="flex-none accent-primary-black"
                      value="OFF"
                      id="할인 미적용"
                      disabled={true}
                      defaultChecked={defaultValues?.discountStatus === "OFF"}
                    />
                    <label htmlFor="할인 미적용">할인 미적용</label>
                  </div>

                  <div className="flex gap-1 items-center">
                    <input
                      type="radio"
                      className="flex-none accent-primary-black"
                      value="EVERY"
                      id="전체기간 할인"
                      disabled={true}
                      defaultChecked={defaultValues?.discountStatus === "EVERY"}
                    />
                    <label htmlFor="전체기간 할인">전체기간 할인</label>
                  </div>

                  <div className="flex gap-1 items-center">
                    <input
                      type="radio"
                      className="flex-none accent-primary-black"
                      value="DATES"
                      id="특정기간만 할인"
                      disabled={true}
                      defaultChecked={defaultValues?.discountStatus === "DATES"}
                    />
                    <label htmlFor="특정기간만 할인">특정기간만 할인</label>
                  </div>
                </div>
                <div className="flex gap-8 items-center">
                  <div className="flex items-center gap-3">
                    <InputDate
                      disabled={true}
                      value={
                        defaultValues?.discountStartDate
                          ? dayjs(defaultValues?.discountStartDate)
                          : null
                      }
                    />
                    {" - "}
                    <InputDate
                      disabled={true}
                      value={
                        defaultValues?.discountEndDate
                          ? dayjs(defaultValues?.discountEndDate)
                          : null
                      }
                    />
                  </div>
                </div>
              </div>
            </FieldBox>
            <FieldBox label="적립 포인트" isLast>
              <div className="flex items-center gap-20">
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-1">
                    <input
                      checked={defaultValues?.pointPurchasePercent}
                      id="pointPurchasePercent"
                      type="checkbox"
                      disabled={true}
                    />
                    <label htmlFor="pointPurchasePercent">결제금액의</label>
                  </div>
                  <div className="flex rounded-[4px]">
                    <input
                      className="w-24 p-1 rounded-l-[2px] border border-grey-button [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                      type="number"
                      placeholder="0"
                      disabled={true}
                      defaultValue={defaultValues?.pointPurchasePercent}
                    />
                    <div className="rounded-r-[2px] border border-grey-button p-1">
                      %
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-1">
                    <input
                      checked={defaultValues?.pointReview}
                      id="pointReview"
                      type="checkbox"
                      disabled={true}
                    />
                    <label htmlFor="pointReview">리뷰작성시</label>
                  </div>
                  <div className="flex rounded-[4px]">
                    <input
                      className="w-48 p-1 rounded-l-[2px] border border-grey-button [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                      type="number"
                      placeholder="0"
                      disabled={true}
                      defaultValue={defaultValues?.pointReview}
                    />
                    <div className="rounded-r-[2px] border border-grey-button p-1">
                      P
                    </div>
                  </div>
                </div>
              </div>
            </FieldBox>
          </li>

          {/* Product input section */}
          <li className="mt-6">
            <h2 className="font-bold text-sm mb-3">3. 개별 상품 정보</h2>

            <div className="flex justify-center">
              <ProductList
                productList={defaultValues?.products}
                isReadOnlyMode
              />
            </div>
          </li>

          <li className="mt-6">
            <h2 className="font-bold text-sm mb-3">4. [공통] 상품 이미지</h2>
            <FieldBox
              label={`대표 이미지 (${
                defaultValues?.mainImage !== "" ? "1" : "0"
              }/1)`}
            >
              <div className="flex flex-wrap items-center p-2 gap-4">
                <label
                  htmlFor="imageInput"
                  className="cursor-not-allowed bg-[#eeeeee]"
                >
                  <div
                    className={` w-[100px] h-[100px]  border border-[#cccccc]`}
                  >
                    <input
                      id="imageInput"
                      type="file"
                      className="hidden"
                      disabled={true}
                    />
                    <AiOutlinePlus className="text-[#707070] m-auto my-auto h-full" />
                  </div>
                </label>
                {defaultValues?.mainImage !== "" && (
                  <div className="relative w-[100px] h-[100px] border border-[#cccccc]">
                    <div className="bg-[#f2dca8] text-[#0f1e3d] absolute left-0 top-0 px-2 py-1 cursor-pointer">
                      1
                    </div>
                    <img
                      src={defaultValues?.mainImage}
                      className="object-cover w-full h-full"
                    />
                  </div>
                )}
              </div>
            </FieldBox>
            <FieldBox
              label={`추가 이미지 (${
                defaultValues?.additionalImages?.length !== 0
                  ? defaultValues?.additionalImages?.length
                  : "0"
              }/7)`}
              isLast
            >
              <div className="flex flex-wrap items-center p-2 gap-4">
                <label
                  htmlFor="moreImageInput"
                  className="cursor-not-allowed bg-[#eeeeee]"
                >
                  <div
                    className={` w-[100px] h-[100px]  border border-[#cccccc]`}
                  >
                    <input
                      id="moreImageInput"
                      type="file"
                      className="hidden"
                      disabled={true}
                    />
                    <AiOutlinePlus className="text-[#707070] m-auto my-auto h-full" />
                  </div>
                </label>
                {defaultValues?.additionalImages
                  ?.slice(0, 7)
                  .map((val, index) => {
                    return (
                      <div
                        key={index}
                        className="relative w-[100px] h-[100px] border border-[#cccccc]"
                      >
                        <div className="bg-[#f2dca8] text-[#0f1e3d] absolute left-0 top-0 px-2 py-1 cursor-pointer">
                          {index + 1}
                        </div>
                        <img src={val} className="object-cover w-full h-full" />
                      </div>
                    );
                  })}
              </div>
            </FieldBox>
          </li>

          <li className="mt-6">
            <h2 className="font-bold text-sm mb-3">5. [공통] 상품 상세정보</h2>
            <EditorViewer
              delta={JSON.parse(defaultValues?.description)}
              className="border text-[12px] border-primary-grey mt-4 px-2 py-2.5 min-h-[300px] overflow-auto"
            />
          </li>

          <li className="mt-6">
            <h2 className="font-bold text-sm mb-3">6. [공통] 배송</h2>

            <FieldBox label="배송비 부과여부">
              <div className="bg-white p-2 w-full">
                {defaultValues?.deliveryType === "PAID"
                  ? "배송비 부과"
                  : "무료배송"}
              </div>
            </FieldBox>
            <FieldBox label="배송비">
              <div className="bg-white p-2 w-full">
                {defaultValues?.deliveryType === "PAID"
                  ? `${defaultValues?.deliveryFee.toLocaleString("KR")}원`
                  : "(해당 없음)"}
              </div>
            </FieldBox>
            <FieldBox label="출고지">
              <div className="bg-white p-2 w-full">
                {defaultValues?.deliveryFromAddress}
              </div>
            </FieldBox>

            <FieldBox label="배송기간" isLast>
              <div className="bg-white p-2 w-full">
                {defaultValues?.deliveryPeriod}
              </div>
            </FieldBox>
          </li>

          <li className="mt-6">
            <h2 className="font-bold text-sm mb-3">7. [공통] 반품/교환</h2>

            <FieldBox label="배송비 부과여부">
              <div className="bg-white p-2 w-full">
                {defaultValues?.refundType === "PAID"
                  ? "배송비 부과"
                  : "무료배송"}
              </div>
            </FieldBox>
            <FieldBox label="반품배송비(편도)">
              <div className="bg-white p-2 w-full">
                {defaultValues?.refundType === "PAID"
                  ? `${defaultValues?.refundPrice1.toLocaleString("KR")}원`
                  : "(해당 없음)"}
              </div>
            </FieldBox>

            <FieldBox label="교환배송비(왕복)">
              <div className="bg-white p-2 w-full">
                {defaultValues?.refundType === "PAID"
                  ? `${defaultValues?.refundPrice2.toLocaleString("KR")}원`
                  : "(해당 없음)"}
              </div>
            </FieldBox>

            <FieldBox label="반품/교환지" isLast>
              <div className="bg-white p-2 w-full">
                {defaultValues?.refundAddress}
              </div>
            </FieldBox>
          </li>
        </ol>

        <div className="mt-24 flex justify-center gap-2 items-center">
          <Modal
            description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
            onSubmit={handleBack}
          >
            <Button text="목록" />
          </Modal>
          <Button
            onClick={handleEdit}
            type="button"
            text="상품정보 변경"
            primary
          />{" "}
        </div>
      </>
    </div>
  );
};

export default ProductGroupDetailPage;
